import mapboxgl, { MapboxGeoJSONFeature } from "mapbox-gl";
import { useEffect } from "react";
import { MapboxSources } from "../../../mapbox";
import { Dict } from "../useDict";
import { allMapboxSourceIds, groupFeaturesBySource } from "./util";

export interface UseClickSelectionHandlerProps {
  map: mapboxgl.Map | null;
  mapboxSources: Dict<MapboxSources>;
  setUniqueSelectedFeatures: (
    featuresByMapboxSource: Dict<MapboxGeoJSONFeature[]>
  ) => void;
}

export default function useClickSelectionHandler(
  props: UseClickSelectionHandlerProps
): void {
  const { map, mapboxSources, setUniqueSelectedFeatures } = props;

  useEffect(() => {
    if (map == null) return;

    const clickHandler = (evt: mapboxgl.MapMouseEvent) => {
      const sourceIds = allMapboxSourceIds(mapboxSources);

      const features = map
        .queryRenderedFeatures(evt.point)
        .filter(feature => sourceIds.includes(feature.source));

      setUniqueSelectedFeatures(groupFeaturesBySource(features));
    };

    map.on("click", clickHandler);
    return () => {
      map.off("click", clickHandler);
    };
  }, [map, mapboxSources, setUniqueSelectedFeatures]);
}
